import React from "react";

class TabsDetails extends React.Component {
  componentDidMount() {
  }
  Certificates = () => {
    this.props.props.history.push({
      pathname: "/multiVendor/categoryDetails/Certificates",
    });
  };
  render() {
    return (
      <>
        <div className="Certificate" onClick={() => this.Certificates()}>
          <div className="CertificateRight">
            <img src="/public/assets/icons/CertificateVen.svg" alt="pic"/>
            <span>گواهینامه های کسب شده</span>
          </div>
          <img src="/public/assets/icons/leftArrowVen.svg" alt="pic"/>
        </div>
        <div className="servicesTime">
          <span className="serviceTxt">سرویس های انجام شده</span>
          <div className="serviceValue1">
            <span className="value">250</span>
            <span className="txt">سرویس</span>
          </div>
        </div>
        <div className="servicesTime cursor">
          <div
            className="rowDetails rowDetailsFirst"
            onClick={(e) =>
              e.currentTarget.parentNode.classList.toggle("activeMulti")
            }
          >
            <span className="serviceTxt">ساعت ها و روزهای کاری</span>
            <div className="serviceValue">
              <span className="txt">امروز</span>
              <span className="value">
                {this.props.mechanicsInfgo.days[0].active_hours}
              </span>
              <img
                className="arrowWWWW"
                src="/public/assets/icons/downArrowPurple.svg"
                alt="pic"/>
            </div>
          </div>
          {this.props.mechanicsInfgo.days.map((item) => (
            <div className="rowDetails">
              <div className="serviceValueTime">
                <span className="serviceTxt">{item.name}</span>
                <span className="serviceValue moreValueHandle">
                  {item.active_hours}
                </span>
              </div>
            </div>
          ))}
        </div>
        <h1 className="titleReservationCom titleReservationComTabs">
          جزئیات بیشتر
        </h1>
        <div className="moreDetailsTabs">
          <div className="rowMoreDetails">
            <span className="circleMoreDetails"></span>
            <span className="txtMoreDetails">
              {this.props.mechanicsInfgo.details}
            </span>
          </div>
        </div>
      </>
    );
  }
}
export default TabsDetails;
